module.exports = __webpack_public_path__ + "static/media/KarinCheung@3x.898b7f81.png";